import { FC } from 'react';
import { useTranslation } from 'react-i18next';
import { RouteComponentProps } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import { ILocaleReq } from '../../../models/i18n.model'
import { doCreateLocale } from '../../../store/locale.slice';
import { doRemoveAuth } from '../../../store/auth.slice';
import { RootState } from '../../../store/rootReducer';
import { useSnackbar } from 'notistack';

import Loader from '../../../components/Loader';
import SimpleHeader from '../../../components/layout/SimpleHeader';
import Footer from '../../../components/layout/Footer';
import Editor from '../../../components/system/locale/Editor';
import { errorVariant, successVariant, warningVariant } from '../../../lib/barVariant';

const SystemLocaleCreate: FC<RouteComponentProps> = ({ history }) => {
  const { t } = useTranslation();
  const { enqueueSnackbar } = useSnackbar();
  const dispatch = useDispatch();
  const { isLoading } = useSelector((state: RootState) => state.locale);

  const onSubmit = async (req: ILocaleReq) => {
    const res = await dispatch(doCreateLocale(req))

    switch (res?.status) {
      case 200:
        enqueueSnackbar(t('common.message.create'), successVariant);
        history.push('/system/locale');
        break;
      case 401:
        dispatch(doRemoveAuth());
        break;
      case 403:
        enqueueSnackbar(t('common.message.forbidden'), warningVariant);
        history.push('/');
        break;
      default:
        enqueueSnackbar(res?.data?.data || t('common.message.error'), errorVariant);
    }
  }

  return (
    <div className="content scrollbar">
      {isLoading ? <Loader /> : null}
      <SimpleHeader
        parentMenu={t('common.menu.system')}
        currentMenu={t('system.locale.title2')}
      />
      <Editor
        locale={null}
        onSubmit={onSubmit}
      />
      <Footer />
    </div>
  )
}

export default SystemLocaleCreate;
